import {RestfulService} from '../rest/restful';
import { Models } from '@ibexfusion/models';
import {RestProvider, RestService} from '../rest/rest.service';
import {Injectable} from '@angular/core';

@Injectable()
export class VotingResultService extends RestfulService<Models.VotingResponse> {
  constructor(public restService: RestService) {
    super(Models.VotingResponse);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('voting-responses');
  }
}
